import "./__thumbnail.scss"; import "./article_page.scss"
import "./__thumbnail.coffee"; import "./article_page.coffee"
